<div class="grid flex-column" *ngIf="document as doc">
  <div class="col">
    <div class="fluid formgrid grid">
      <div class="col-12 xl:col-4 sm:col-12">
        <app-companyselector [labelKey]="cliCliLabel" [parentCompany]="0" [selectedID]="doc.DOCCLIENTSID" [showTierBadge]="true" (selectedCompanyID)="cliCompanySelected($event)"></app-companyselector>
      </div>
      <div class="col-12 xl:col-4 sm:col-12">
        <app-personselector [labelKey]="cliPerLabel" [parentCompany]="doc.DOCCLIENTSID" firstAvailable="true" [selectedID]="doc.DOCPERSONID"
                            (selectedPersonID)="cliPersonSelected($event)"></app-personselector>
      </div>
      <div class="col-12 xl:col-4 sm:col-12">
        <app-departmentselector [labelKey]="cliDepLabel" [parentCompany]="doc.DOCCLIENTSID" [selectedID]="doc.DOCCLIDEPID"
                                (selectedDepartmentID)="cliStockSelected($event)"></app-departmentselector>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="fluid formgrid grid">
      <div class="col-12 xl:col-4 sm:col-12">
        <app-companyselector [labelKey]="pcoCliLabel" [parentCompany]="doc.DOCCLIENTSID" [selectedID]="doc.DOCPCOCLIID"
                             (selectedCompanyID)="pcoCompanySelected($event)"></app-companyselector>
      </div>
      <div class="col-12 xl:col-4 sm:col-12">
        <app-personselector [labelKey]="pcoPerLabel" [parentCompany]="doc.DOCPCOCLIID"  firstAvailable="true" [selectedID]="doc.DOCPCOPERID" select="first"
                            (selectedPersonID)="pcoPersonSelected($event)"></app-personselector>
      </div>
      <div class="col-12 xl:col-4 sm:col-12">
        <app-departmentselector [labelKey]="pcoDepLabel"
                                [disabled]="true"
                                [parentCompany]="doc.DOCPCOCLIID"
                                [selectedID]="doc.DOCPCODEPID"
                                [masterID]="doc.DOCCLIDEPID"
                                (selectedDepartmentID)="pcoStockSelected($event)">
        </app-departmentselector>
      </div>
    </div>
  </div>
</div>
